import React, { useEffect, useState } from 'react';
import { Button, Row } from 'react-bootstrap';
import Media from 'react-media';
import LeftSideNavigation from '../../../../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation';
import { TopNavigationBarMobile } from '../../../../../../../vendorDashboardComponents/navigationSection/TopNavigationBarMobile';
import RightSideNavigation from '../../../../../../../vendorDashboardComponents/navigationSection/RightSideNavigation';
import BottomNavigationMobile from '../../../../../../../vendorDashboardComponents/navigationSection/BottomNavigationMobile';
import { useFormik } from 'formik';
import {
  errorAlert,
  successAlert,
} from '../../../../../../../../function/alert';
import BasicInformation from './BasicInformation';
import * as yup from 'yup';
import { get_category_menu_setup } from '../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ItemSetup from './ItemSetup';
import AddCondiments from './AddCondiments';
import Availability from './Availability';
import Pricing from './Pricing';
import { amApi } from '../../../../../../../../api/apiHelper';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

function CreateCombos(props) {
  const [selectedTab, setSelectedTab] = useState(1);
  const history = useHistory();
  const location = useLocation();
  const [count, setCount] = useState(3);
  const [comboDetails, setComboDetails] = useState(null);

  const isEditMode = location.pathname.includes('/editcombo');

  const comboId = isEditMode ? location.pathname.split('/').pop() : null;

  useEffect(() => {
    if (isEditMode && comboId) {
      console.log('edit');
      amApi
        .get(`/combo/${comboId}`)
        .then((res) => {
          setComboDetails(res.data); // Populate the form with existing combo details
        })
        .catch((err) => {
          errorAlert('Failed to load combo details');
        });
    }
  }, [isEditMode, comboId]);

  const formik1 = useFormik({
    enableReinitialize: true,
    initialValues: {
      categoryName: comboDetails?.categoryName || '',
      category_id: comboDetails?.category_id,
      comboName: comboDetails?.comboName || '',
      type: 'Combo',
      description: comboDetails?.description || '',
      images: comboDetails?.images?.[0] ? [comboDetails?.images?.[0]] : [],
      keywords: comboDetails?.keywords,
    },
    validationSchema: yup.object({
      categoryName: yup.string().required('category is required'),
      comboName: yup.string().required('Combo Name is required'),
      description: yup.string().required('Descriptionis required'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        setSelectedTab(2);
      } catch (error) {
        errorAlert('An error occurred during submission');
      } finally {
        setSubmitting(false);
      }
    },
  });

  const onSuccessStepLoader = () => {};

  useEffect(() => {
    if (props?.auth) {
      const token = props.auth.user.accessToken;
      props.get_category_menu_setup(token, onSuccessStepLoader);
    }
  }, []);

  const handleTab = (e) => {
    setSelectedTab(e);
  };

  const onClickForm1Save = () => {
    setCount(count + 1);
    formik1.handleSubmit();
  };

  const onClickForm2Save = () => {
    setCount(count + 1);
    formik2.handleSubmit();
  };
  const onClickForm3Save = () => {
    setCount(count + 1);
    formik3.handleSubmit();
  };
  const onClickForm4Save = () => {
    setCount(count + 1);
    formik4.handleSubmit();
  };
  const onClickForm5Save = () => {
    setCount(count + 1);
    formik5.handleSubmit();
  };

  const formik2 = useFormik({
    enableReinitialize: true,
    initialValues: {
      comboItems:
        comboDetails?.comboItems?.map((combo) => ({
          ...combo,
          items: combo.items.map((item) => ({
            additionalPrice: item.additionalPrice,
            default: item.default,
            ...item._id,
          })),
        })) || [],
      substitutable: comboDetails?.substitutable || false,
    },
    validationSchema: yup.object({
      comboItems: yup
        .array()
        .min(1, 'You must add at least one item.')
        .required('Items are required'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        handleTab(3);
        console.log('Pricing form submitted', values);
      } catch (error) {
        errorAlert('An error occurred during submission');
      } finally {
        setSubmitting(false);
      }
    },
  });

  const formik3 = useFormik({
    enableReinitialize: true,
    initialValues: {
      condiments: comboDetails?.condiments?.length
        ? comboDetails.condiments
        : [
            {
              description: '',
              price: '',
              additionals: [],
            },
          ],
    },

    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        console.log('Condiments form submitted', values);
        handleTab(4);
      } catch (error) {
        errorAlert('An error occurred during submission');
      } finally {
        setSubmitting(false);
      }
    },
  });

  const formik4 = useFormik({
    enableReinitialize: true,
    initialValues: {
      activeStatus: comboDetails?.activeStatus || false,
      availability: comboDetails?.availability || false,
      date_of_availability: {
        start_date: comboDetails?.date_of_availability?.start_date || '',
        end_date: comboDetails?.date_of_availability?.end_date || '',
      },
      time_of_availability: {
        start_time: comboDetails?.time_of_availability?.start_time || '',
        end_time: comboDetails?.time_of_availability?.end_time || '',
      },
      cutOffTimeOption: comboDetails?.cutOffTimeOption || '',
      leadTimeOption: comboDetails?.leadTimeOption || '',
      lead_time: comboDetails?.lead_time || '',
      cut_off_time: comboDetails?.cut_off_time || '',
      weeklyAvailability: {
        monday: comboDetails?.weeklyAvailability?.monday || { open: false },
        tuesday: comboDetails?.weeklyAvailability?.tuesday || { open: false },
        wednesday: comboDetails?.weeklyAvailability?.wednesday || {
          open: false,
        },
        thursday: comboDetails?.weeklyAvailability?.thursday || { open: false },
        friday: comboDetails?.weeklyAvailability?.friday || { open: false },
        saturday: comboDetails?.weeklyAvailability?.saturday || { open: false },
        sunday: comboDetails?.weeklyAvailability?.sunday || { open: false },
      },
    },

    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        console.log('Condiments form submitted', values);
        handleTab(5);
      } catch (error) {
        errorAlert('An error occurred during submission');
      } finally {
        setSubmitting(false);
      }
    },
  });

  const formik5 = useFormik({
    enableReinitialize: true,
    initialValues: {
      selectedTypes: comboDetails?.selectedTypes || [],
      pricing: {
        dineIn: {
          listPrice: comboDetails?.pricing?.dineIn?.listPrice || '',
          comboPrice: comboDetails?.pricing?.dineIn?.comboPrice || '',
          packingCharges: comboDetails?.pricing?.dineIn?.packingCharges || '',
        },
        delivery: {
          listPrice: comboDetails?.pricing?.delivery?.listPrice || '',
          comboPrice: comboDetails?.pricing?.delivery?.comboPrice || '',
          packingCharges: comboDetails?.pricing?.delivery?.packingCharges || '',
        },
        takeAway: {
          listPrice: comboDetails?.pricing?.takeAway?.listPrice || '',
          comboPrice: comboDetails?.pricing?.takeAway?.comboPrice || '',
          packingCharges: comboDetails?.pricing?.takeAway?.packingCharges || '',
        },
        curbSide: {
          listPrice: comboDetails?.pricing?.curbSide?.listPrice || '',
          comboPrice: comboDetails?.pricing?.curbSide?.comboPrice || '',
          packingCharges: comboDetails?.pricing?.curbSide?.packingCharges || '',
        },
        skipTheLine: {
          listPrice: comboDetails?.pricing?.skipTheLine?.listPrice || '',
          comboPrice: comboDetails?.pricing?.skipTheLine?.comboPrice || '',
          packingCharges:
            comboDetails?.pricing?.skipTheLine?.packingCharges || '',
        },
      },
    },

    onSubmit: (values) => {
      let formData = {
        ...formik1.values,
        ...formik2.values,
        ...formik3.values,
        ...formik4.values,
        ...formik5.values,
      };
      formData.restaurant =
        props?.onboarding?.onboard_subscription_details?._id;
      formData.vendor_id =
        props?.onboarding?.onboard_subscription_details?.vendor_id;
      formData.type = 'Combo';
      formData.isVeg = 'Veg';
      if (isEditMode && comboId) {
        amApi
          .patch(`/combo/${comboId}`, formData)
          .then((res) => {
            successAlert('Combo Updated Successfully');
            history.push('/menusetup-dashboard');
            formik1.resetForm();
            formik2.resetForm();
            formik3.resetForm();
            formik4.resetForm();
            formik5.resetForm();
          })
          .catch((err) => {
            //  setDisabled(false);
            errorAlert(
              err?.response?.data?.message ||
                'Something went wrong, try again later'
            );
          });
      } else {
        amApi
          .post('/combo', formData)
          .then((res) => {
            successAlert('Combo Create Successfully');
            history.push('/menusetup-dashboard');
            formik1.resetForm();
            formik2.resetForm();
            formik3.resetForm();
            formik4.resetForm();
            formik5.resetForm();
          })
          .catch((err) => {
            //  setDisabled(false);
            errorAlert(
              err?.response?.data?.message ||
                'Something went wrong, try again later'
            );
          });
      }
    },
  });

  // console.log(comboDetails, formik1.values);
  // console.log(props?.onboarding?.onboard_subscription_details);

  return (
    <React.Fragment>
      <div className="container-fluid add-item-availability">
        <Row>
          <Media query="(min-width: 992px)">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
          </Media>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation
              leftText="vendorReview"
              // backButtonLink="/categorydashboard"
              backButtonLink="/menusetup-dashboard"
              displayText="Back"
              noEnAdminPic={true}
            />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Combo Setup</div>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <Button
                    variant="link"
                    className={`px-0 mx-2 text-grayLink f10-500 ${
                      selectedTab === 1 ? 'active' : ''
                    }`}
                    // onClick={() => handleTab(1)}
                  >
                    Basic Information
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mx-2 text-grayLink f10-500 ${
                      selectedTab === 2 ? 'active' : ''
                    }`}
                    onClick={() => handleTab(2)}
                  >
                    Item Setup
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mx-2 text-grayLink f10-500 ${
                      selectedTab === 3 ? 'active' : ''
                    }`}
                    onClick={() => handleTab(3)}
                  >
                    Add Condiments
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mx-2 text-grayLink f10-500 ${
                      selectedTab === 4 ? 'active' : ''
                    }`}
                    onClick={() => handleTab(4)}
                  >
                    Availability
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mx-2 text-grayLink f10-500 ${
                      selectedTab === 5 ? 'active' : ''
                    }`}
                    onClick={() => handleTab(5)}
                  >
                    Pricing
                  </Button>
                </div>
              </div>
              <hr />
            </div>
            <div>
              {selectedTab === 1 && (
                <BasicInformation formik={formik1} menu={props?.menuCategory} />
              )}
              {selectedTab === 2 && (
                <ItemSetup formik={formik2} menu={props?.menuCategory} />
              )}
              {selectedTab === 3 && <AddCondiments formik={formik3} />}
              {selectedTab === 4 && (
                <Availability
                  formik={formik4}
                  data={formik1}
                  comboDetails={comboDetails}
                />
              )}
              {selectedTab == 5 && <Pricing formik={formik5} />}

              <div className="py-4 d-flex align-items-center">
                <Button
                  variant="outline-secondary"
                  className="btn-lg mr-4 px-5 btn150px"
                  type="button"
                  onClick={() => {
                    if (selectedTab === 1) {
                      history.push('/menusetup-dashboard');
                    } else {
                      handleTab(selectedTab - 1);
                    }
                  }}
                >
                  {selectedTab === 1 ? 'Cancel' : 'Back'}
                </Button>
                <Button
                  variant="danger"
                  className="btn-lg px-5 btn150px"
                  type="button"
                  // disabled={disabled}
                  onClick={() => {
                    if (selectedTab === 5) {
                      onClickForm5Save();
                    } else if (selectedTab === 2) {
                      onClickForm2Save();
                    } else if (selectedTab === 3) {
                      onClickForm3Save();
                    } else if (selectedTab === 4) {
                      onClickForm4Save();
                    } else {
                      onClickForm1Save();
                    }
                    //  setCount(count + 1);
                    //  formik.validateForm()
                  }}
                >
                  {selectedTab === 5 ? 'Save' : 'Next'}
                </Button>
              </div>
            </div>
          </div>

          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
          <div className="bottom-panel"></div>
        </Row>
      </div>
    </React.Fragment>
  );
}

CreateCombos.propTypes = {
  auth: PropTypes.object.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
  customMenuList: PropTypes.object.isRequired,
  ActiveMenu: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  menuCategory: state.onboarding && state.onboarding.menuCategory,
  onboarding: state.onboarding && state.onboarding,
});

export default connect(mapStateToProps, {
  get_category_menu_setup,
})(CreateCombos);
